export default __webpack_public_path__ + "images/card-logo-americanexpress.c8f53701d7231dd34f836d53ab93cb39.png";